import actionTypes from './actionTypes';

const initialState = {
	product: undefined,
	userInfo: {
		familyName: { value: '', valid: false, required: true },
		name: { value: '', valid: false, required: true },
		tel: { value: '', valid: false, required: true },
		email: { value: '', valid: false, required: true },
	},
	mail: {
		subject: { value: '', valid: false, required: true },
		message: { value: '', valid: false, required: true },
		file: { value: '', valid: false, required: false },
		rentDate: { value: '', valid: false, required: false },
		rentDescription: { value: '', valid: false, required: false },
	},
	isFormValid: false,
	isSending: false,
	sendingFailed: false,
	sendingSucceeded: false,
};

export default function contentReducer(state = initialState, action) {
	switch (action.type) {
		case actionTypes.VALIDATE_FORM:
			return {
				...state,
				isFormValid: action.valid,
			};
		case actionTypes.INIT_MAIL:
			return {
				...state,
				product: undefined,
				isFormValid: false,
				userInfo: {
					familyName: { value: '', valid: false, required: true },
					name: { value: '', valid: false, required: true },
					tel: { value: '', valid: false, required: true },
					email: { value: '', valid: false, required: true },
				},
				mail: {
					subject: { value: '', valid: false, required: true },
					message: { value: '', valid: false, required: true },
					file: { value: '', valid: false, required: false },
					rentDate: { value: '', valid: false, required: false },
					rentDescription: { value: '', valid: false, required: false },
				},
			};
		case actionTypes.SET_MAIL_INFO:
			return {
				...state,
				userInfo: {
					...state.userInfo,
					familyName: { ...state.userInfo.familyName, ...action.userInfo.familyName },
					name: { ...state.userInfo.name, ...action.userInfo.name },
					tel: { ...state.userInfo.tel, ...action.userInfo.tel },
					email: { ...state.userInfo.email, ...action.userInfo.email },
				},
				mail: {
					...state.mail,
					subject: { ...state.mail.subject, ...action.mail.subject },
					message: { ...state.mail.message, ...action.mail.message },
					file: { ...state.mail.file, ...action.mail.file },
					rentDate: { ...state.mail.rentDate, ...action.mail.rentDate },
					rentDescription: { ...state.mail.rentDescription, ...action.mail.rentDescription },
				},
			};
		case actionTypes.SEND_MAIL:
			return {
				...state,
				documents: action.data,
			};
		case actionTypes.CONTACT_FOR_PRODUCT:
			return {
				...state,
				product: action.product,
				mail: {
					...state.mail,
					subject: { ...state.mail.subject, ...action.mail.subject },
				},
			};
		case actionTypes.SENDING_FAILED:
			return {
				...state,
				isSending: false,
				sendingFailed: true,
			};
		case actionTypes.SENDING_IN_PROGRESS:
			return {
				...state,
				isSending: true,
				sendingFailed: false,
				sendingSucceeded: false,
			};
		case actionTypes.SENDING_SUCCEEDED:
			return {
				...state,
				isSending: false,
				sendingSucceeded: true,
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/contact/contactReducer.js